var React = require('react');

function IconArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M7.5,13L7.5,13L0,0l0,0h15l0,0L7.5,13z"}));
}

IconArrowDown.defaultProps = {"version":"1.1","viewBox":"0 0 15 13","style":{"enableBackground":"new 0 0 15 13"},"xmlSpace":"preserve"};

module.exports = IconArrowDown;

IconArrowDown.default = IconArrowDown;
